export default theme => ({
  root: {
    textAlign: 'center',
    marginBottom: 24,
    '& > * + *': {
      marginTop: 16
    }
  }
});